import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber'

// 日本の国コード
const region = 'JP'

export const formatTelNumber = (value) => {
  const util = PhoneNumberUtil.getInstance()

  // 番号と地域を設定
  const number = util.parseAndKeepRawInput(value, region)

  // 電話番号の有効性チェック
  if (!util.isValidNumberForRegion(number, region)) {
    return null
  }

  // ハイフン付きの形式で返却
  return util.format(number, PhoneNumberFormat.NATIONAL)
}
